var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1875 1875",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.437,1026.91c-5.563,43.289 -2.674,169.39 19.974,249.79c8.986,31.902 14.754,84.433 35.803,127.105c34.315,69.569 86.038,126.565 86.038,126.565c21.055,16.749 70.914,67.991 126.332,100.497c55.635,32.633 115.881,41.574 115.881,41.574c-0,0 111.638,14.626 167.805,17.385c58.974,2.898 124.204,4.708 186.038,0c64.874,-4.938 137.073,-11.954 203.202,-29.63c71.416,-19.09 155.363,-46.384 225.297,-84.909c69.934,-38.524 142.492,-94.513 194.307,-146.241c47.492,-47.412 116.584,-164.129 116.584,-164.129l108.403,-220.395l111.471,-8.407l104.656,-50.736c0,0 78.045,-74.665 70.221,-99.371c-7.825,-24.705 -117.168,-48.86 -117.168,-48.86c0,0 -102.77,28.852 -132.364,9.999c-29.593,-18.853 -45.199,-123.118 -45.199,-123.118c0,-0 -75.355,-95.733 -100.02,-95.733c-24.664,-0 -47.966,95.733 -47.966,95.733c0,-0 -22.598,73.065 -22.598,103.687c0,27.725 22.598,80.047 22.598,80.047c0,-0 38.618,47.171 21.377,59.036c-23.708,16.317 -163.627,38.862 -163.627,38.862l-1173,-0c0,-0 -43.733,-3.542 -62.74,-0c-17.783,3.313 -48.998,3.308 -51.303,21.249Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.064,1476.17l-130.744,55.111l-70.774,10.511l-86.465,5.72l48.889,46.06l57.704,30.831l119.866,36.993l138.196,18.249l169.423,-6.468l-246.095,-197.007Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.072,1531.12c-0,-0 115.013,2.263 168.901,-9.845c53.888,-12.109 154.426,-62.806 154.426,-62.806",
    style: {
      fill: "none",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.855,
    cy: 1345.04,
    r: 67.701,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.378,1334.1c1.038,3.464 1.596,7.136 1.596,10.938c-0,21.038 -17.081,38.118 -38.119,38.118c-21.038,0 -38.119,-17.08 -38.119,-38.118c0,-21.038 17.081,-38.119 38.119,-38.119c3.802,0 7.474,0.558 10.938,1.596c-6.466,3.088 -10.938,9.691 -10.938,17.329c0,10.594 8.6,19.194 19.193,19.194c7.639,-0 14.242,-4.472 17.33,-10.938Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M344.84,813.051c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,0c11.23,0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.917,849.266c-0,-3.475 -2.821,-6.295 -6.296,-6.295l-12.59,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,-0c3.475,-0 6.296,-2.821 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.735,849.266c0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,-0c3.474,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.098,849.266c-0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,-0c3.474,-0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M566.708,813.051c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,0c11.23,0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.784,849.266c0,-3.475 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,-0c3.475,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.603,849.266c0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,-0c3.474,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.966,849.266c-0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,-0c3.474,-0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M788.576,813.051c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,0c11.23,0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.652,849.266c0,-3.475 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,-0c3.475,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.471,849.266c0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.296,2.82 -6.296,6.295l0,94.79c0,3.474 2.821,6.295 6.296,6.295l12.59,-0c3.474,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.834,849.266c-0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,-0c3.474,-0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1010.44,813.051c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,0c11.23,0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.52,849.266c0,-3.475 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,-0c3.475,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.339,849.266c0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.296,2.82 -6.296,6.295l0,94.79c0,3.474 2.821,6.295 6.296,6.295l12.59,-0c3.474,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.702,849.266c-0,-3.475 -2.821,-6.295 -6.296,-6.295l-12.59,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,-0c3.475,-0 6.296,-2.821 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1232.31,813.051c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,0c11.23,0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.39,849.266c0,-3.475 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,-0c3.475,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.21,849.266c-0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,-0c3.474,-0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.57,849.266c-0,-3.475 -2.821,-6.295 -6.296,-6.295l-12.59,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,-0c3.475,-0 6.296,-2.821 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1232.31,609.576c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.348 20.347,20.348l181.173,-0c11.23,-0 20.348,-9.118 20.348,-20.348l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.39,645.791c0,-3.474 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,0c3.475,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.21,645.791c-0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,0c3.474,0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.57,645.791c-0,-3.474 -2.821,-6.295 -6.296,-6.295l-12.59,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,0c3.475,0 6.296,-2.821 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M566.708,609.576c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.348 20.347,20.348l181.173,-0c11.23,-0 20.348,-9.118 20.348,-20.348l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.784,645.791c0,-3.474 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,0c3.475,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.603,645.791c0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,0c3.474,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.966,645.791c-0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,0c3.474,0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M788.576,609.576c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.348 20.347,20.348l181.173,-0c11.23,-0 20.348,-9.118 20.348,-20.348l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.652,645.791c0,-3.474 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,0c3.475,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.471,645.791c0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.296,2.821 -6.296,6.295l0,94.79c0,3.474 2.821,6.295 6.296,6.295l12.59,0c3.474,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.834,645.791c-0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.591,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l0,94.79c0,3.474 2.821,6.295 6.295,6.295l12.591,0c3.474,0 6.295,-2.821 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M788.576,406.102c-0,-11.23 -9.118,-20.348 -20.348,-20.348l-181.173,0c-11.23,0 -20.347,9.118 -20.347,20.348l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,-0c11.23,-0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.652,442.316c0,-3.474 -2.82,-6.295 -6.295,-6.295l-12.59,0c-3.474,0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.475 2.821,6.295 6.295,6.295l12.59,0c3.475,0 6.295,-2.82 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.471,442.316c0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.59,0c-3.475,0 -6.296,2.821 -6.296,6.295l0,94.79c0,3.475 2.821,6.295 6.296,6.295l12.59,0c3.474,0 6.295,-2.82 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.834,442.316c-0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.591,0c-3.474,0 -6.295,2.821 -6.295,6.295l0,94.79c0,3.475 2.821,6.295 6.295,6.295l12.591,0c3.474,0 6.295,-2.82 6.295,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1010.44,609.576c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.348 20.347,20.348l181.173,-0c11.23,-0 20.348,-9.118 20.348,-20.348l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.52,645.791c0,-3.474 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,0c3.475,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.339,645.791c0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.296,2.821 -6.296,6.295l0,94.79c0,3.474 2.821,6.295 6.296,6.295l12.59,0c3.474,0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.702,645.791c-0,-3.474 -2.821,-6.295 -6.296,-6.295l-12.59,-0c-3.474,-0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,0c3.475,0 6.296,-2.821 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1010.44,406.102c-0,-11.23 -9.118,-20.348 -20.348,-20.348l-181.173,0c-11.23,0 -20.347,9.118 -20.347,20.348l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,-0c11.23,-0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.52,442.316c0,-3.474 -2.82,-6.295 -6.295,-6.295l-12.59,0c-3.475,0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.475 2.82,6.295 6.295,6.295l12.59,0c3.475,0 6.295,-2.82 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.339,442.316c0,-3.474 -2.821,-6.295 -6.295,-6.295l-12.59,0c-3.475,0 -6.296,2.821 -6.296,6.295l0,94.79c0,3.475 2.821,6.295 6.296,6.295l12.59,0c3.474,0 6.295,-2.82 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.702,442.316c-0,-3.474 -2.821,-6.295 -6.296,-6.295l-12.59,0c-3.474,0 -6.295,2.821 -6.295,6.295l-0,94.79c-0,3.475 2.821,6.295 6.295,6.295l12.59,0c3.475,0 6.296,-2.82 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1010.44,202.627c-0,-11.23 -9.118,-20.347 -20.348,-20.347l-181.173,-0c-11.23,-0 -20.347,9.117 -20.347,20.347l-0,162.78c-0,11.23 9.117,20.347 20.347,20.347l181.173,0c11.23,0 20.348,-9.117 20.348,-20.347l-0,-162.78Z",
    style: {
      fill: "#2497ed",
      stroke: "#2854a1",
      strokeWidth: "32.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.52,238.842c0,-3.475 -2.82,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.82,6.295 6.295,6.295l12.59,-0c3.475,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.339,238.842c0,-3.475 -2.821,-6.295 -6.295,-6.295l-12.59,-0c-3.475,-0 -6.296,2.82 -6.296,6.295l0,94.79c0,3.474 2.821,6.295 6.296,6.295l12.59,-0c3.474,-0 6.295,-2.821 6.295,-6.295l0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.702,238.842c-0,-3.475 -2.821,-6.295 -6.296,-6.295l-12.59,-0c-3.474,-0 -6.295,2.82 -6.295,6.295l-0,94.79c-0,3.474 2.821,6.295 6.295,6.295l12.59,-0c3.475,-0 6.296,-2.821 6.296,-6.295l-0,-94.79Z",
    style: {
      fill: "#2854a1"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.c160ccd679a60c012c31da9c1eaed072.svg";
export { ForwardRef as ReactComponent };